import { Amount } from '@mews-commander/data-access';
import { LocalizedCurrencyValue, lt } from '@mews/framework';
import { useGetPaymentRequestDetailSuspense } from '../hooks';
import { PaymentLinkDetailItem } from '../../PaymentLink/PaymentLinkDetails/PaymentLinkDetailItem';

export const PaymentRequestAmountInfoRow = ({ paymentRequestId }: { paymentRequestId: string }) => {
    const { data: paymentRequest } = useGetPaymentRequestDetailSuspense({ paymentRequestId });

    if (!paymentRequest || !paymentRequest?.amount || !paymentRequest?.amount.value) {
        return null;
    }

    const amount = {
        currency: paymentRequest.amount.currencyCode,
        value: paymentRequest.amount?.value,
    } satisfies Amount;

    return (
        <PaymentLinkDetailItem
            description={lt('GeneralAmountPrice')}
            value={<LocalizedCurrencyValue value={amount} />}
        />
    );
};
